import ServiceReports from '../../../../../services/ServiceReports';

class Service extends ServiceReports {
  constructor() {
    super('/callcenter/pause');
  }
}

export default new Service();
